import { getAmericanTime } from '@helpers/getAmericanTimezone';

import { usePageContext } from '../../../../../../providers/PageProvider';
import { Divider } from '../../styles/Divider';
import { FullWidthSectionRight } from '../../styles/FullWidthSectionRight';
import { InfoBlockFullSize } from '../../styles/InfoBlockFullSize';
import { JobSection } from '../../styles/JobSection';
import { JobSectionLeft } from '../../styles/JobSectionLeft';
import { CellContent } from './styles/CellContent';
import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { JobDtoAssigneeHistory } from 'app/API';

export const AssigneeHistorySection = () => {
  const { job } = usePageContext();

  if (!job || !job.assigneeHistory?.length) {
    return null;
  }

  return (
    <>
      <JobSection>
        <JobSectionLeft>Workflow</JobSectionLeft>
        <FullWidthSectionRight>
          <InfoBlockFullSize>
            <TableWrapper>
              <Table style={{ width: '100%', margin: '-10px 0 0' }}>
                <Thead>
                  <Tr style={{ border: 'none' }}>
                    <Th style={{ width: '200px', padding: 0, height: '40px' }}>Change date</Th>
                    <Th style={{ width: '500px', padding: 0, height: '40px' }}>User assigned</Th>
                    <Th style={{ padding: 0, height: '40px' }}>Actor</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {job.assigneeHistory?.map((item: JobDtoAssigneeHistory, index: number) => (
                    <Tr key={index}>
                      <Td>
                        <CellContent>{getAmericanTime(item.createdAt)}</CellContent>
                      </Td>
                      <Td>
                        <CellContent>
                          {!item.user?.name ? 'Unassigned' : `${item.user.name} ${item.user.lastname}`}
                        </CellContent>
                      </Td>
                      <Td>
                        <CellContent>
                          {!item.createdByUser?.name
                            ? 'Unknown'
                            : `${item.createdByUser.name} ${item.createdByUser.lastname}`}
                        </CellContent>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableWrapper>
          </InfoBlockFullSize>
        </FullWidthSectionRight>
      </JobSection>
      <Divider />
    </>
  );
};
